/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'
import styled from 'styled-components'

import { Participants, Rocket } from 'components/lib/DesignSystem/Icons'
import { Table } from 'components/lib/DesignSystem/V3'
import Button, { VARIANTS } from 'components/lib/DesignSystem/V3/Button'
import { PSIMA_PENDO_FEATURES } from 'components/pages/SpearPhishingAgent/psimaPendo'

import { DetailsInfoSubTitle, DetailsInfoTitle, ParticipantsTableWrapper } from '../styles'

// Override V3 Button `floating` box-shadow (--t-custom-shadow is #EAEFFF; reads as a white
// glow on dark cards). Reuse the PSIMA filter-chip shadow token (none in light, dark drop
// shadow in dark) and theme focus ring instead of V3's #bdd2ff ring.
const LaunchSimulationButton = styled(Button)`
  && > span {
    color: var(--button-secondary-text-default);
    background-color: var(--button-secondary-bg-default);
    border-color: var(--button-secondary-border-default);
    box-shadow: var(--psima-filter-chip-shadow);
  }

  &&:not(:disabled):hover > span {
    color: var(--button-secondary-text-hover);
    background-color: var(--button-secondary-bg-hover);
    border-color: var(--button-secondary-border-hover);
  }

  &&:not(:disabled):hover > span,
  &&:not(:disabled):focus > span,
  &&:not(:disabled):focus-visible > span,
  &&:not(:disabled):focus-within > span,
  &&:not(:disabled):active > span {
    box-shadow: var(--psima-filter-chip-shadow);
  }

  &&:not(:disabled):focus-visible > span {
    box-shadow:
      var(--psima-filter-chip-shadow),
      0 0 0 3px var(--input-focus-ring-default);
  }

  &&:disabled > span {
    color: var(--button-secondary-text-disabled);
    background-color: var(--button-secondary-bg-disabled);
    border-color: var(--button-secondary-border-disabled);
    box-shadow: none;
  }
`

const ParticipantsSection = ({
  campaignId,
  participantsCount,
  columns,
  participantsData,
  getParticipantDuplicateState,
  isLaunchDisabled,
  onLaunchSimulation,
}) => (
  <>
    <DetailsInfoTitle>
      <Participants width="16px" height="16px" fill="var(--color-text)" />
      <div>{participantsCount === 1 ? 'Participant' : 'Participants'}</div>
      <DetailsInfoSubTitle data-testid={`Psima_Dashboard_DetailsInfoSubTitle_span-${campaignId}`}>
        ({participantsCount})
      </DetailsInfoSubTitle>
    </DetailsInfoTitle>
    <ParticipantsTableWrapper>
      <Table
        columns={columns}
        data={participantsData}
        rowClassName={(row) =>
          getParticipantDuplicateState(campaignId, row.id) === 'loser' ? 'psima-duplicate-row' : ''
        }
      />
    </ParticipantsTableWrapper>
    <div style={{ marginTop: '30px' }}>
      <LaunchSimulationButton
        dataTestId={`Psima_Dashboard_ExcludeAllButton_button-${campaignId}`}
        dataPendoFeature={PSIMA_PENDO_FEATURES.DASHBOARD_LAUNCH_SIMULATION}
        variant={VARIANTS.SECONDARY}
        disabled={isLaunchDisabled}
        floating
        onClick={() => onLaunchSimulation(campaignId)}
        leftElement={<Rocket width="16px" height="16px" />}
      >
        Launch Simulation
      </LaunchSimulationButton>
    </div>
  </>
)

export default ParticipantsSection
